const getRequisitionPrintTemplate = (data) => {

  const req = data.requisition || {};   // ✅ FIX

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };
  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date =
      new Date(dateString);

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const year =
      date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const toInitCap = (text) => {
    if (!text) return "-";

    return text
      .toLowerCase()
      .split(" ")
      .map(word => {
        if (word === "po") return "PO"; // keep PO uppercase
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const reportData = data.items || [];

  const approvalItem = reportData.find(
    item =>
      item.approvedByAdmin ||
      item.approvedBySuperAdmin ||
      item.approvedByBoss
  ) || {};

  const adminName = approvalItem.approvedByAdmin || "";
  const adminDate = approvalItem.adminApprovedAt || "";

  const superAdminName = approvalItem.approvedBySuperAdmin || "";
  const superAdminDate = approvalItem.superAdminApprovedAt || "";

  const bossName = approvalItem.approvedByBoss || "";
  const bossDate = approvalItem.bossApprovedAt || "";

  return `
<html lang="en">
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<title>Requisition</title>

<style>
  body {
  font-family: Arial, sans-serif;
  background-color: #f7fafc;
  color: #000;
  margin: 0;
  padding: 16px;
}

  * {
    box-sizing: border-box;
  }
</style>
</head>

<body>

<div style="
  width:100%;
  max-width:1024px;
  margin:0 auto;
  background:#ffffff;
  padding:24px;
  box-shadow:0 4px 6px rgba(0,0,0,0.1);
">
<!-- ==========================================
     HEADER
=========================================== -->

<div style="
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  width:100%;
">

  <!-- LEFT : COMPANY DETAILS -->
  <div>

    <h1 style="
      font-size:20px;
      font-weight:700;
      margin:0 0 6px 0;
      line-height:1.2;
    ">
      Indigo Infraprojects Pvt. Ltd.
    </h1>

    <div style="
      font-size:14px;
      line-height:1.45;
    ">
      3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17, Dwarka<br/>
      New Delhi - 110075
    </div>

  </div>


  <!-- RIGHT : LOGO -->
  <div style="text-align:right;">

    <img
      src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
      alt="Indigo Infraprojects Pvt. Ltd."
      width="110"
      height="55"
      style="
        display:block;
        object-fit:contain;
      "
    />

  </div>

</div>


<!-- ==========================================
     TITLE
=========================================== -->

<div style="
  text-align:center;
  margin-top:18px;
  margin-bottom:30px;
">

  <h2 style="
    font-size:20px;
    font-weight:700;
    margin:0;
    text-transform:uppercase;
  ">
    REQUISITION (DIGITAL COPY)
  </h2>

</div>

<!-- STATUS -->
${(() => {
      const rawStatus = req.status;

      let statusText = rawStatus;

      if (rawStatus === "open") {
        statusText = "Open";
      }
      else if (rawStatus === "submit") {
        statusText = "Pending With Project Manager";
      }
      else if (rawStatus === "adminSubmit") {
        statusText = "Pending With Central Team";
      }
      else if (rawStatus === "pendingWithBoss") {
        statusText = "Pending With HO";
      }
      else if (rawStatus === "close") {
        statusText = "Closed";
      }
      else {
        // ✅ If no mapping exists, show the actual DB status
        statusText = rawStatus || "-";
      }

      return `

<div style="
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  width:100%;
  margin-bottom:18px;
  font-size:12px;
  line-height:1.45;
">

  <!-- LEFT DETAILS -->
  <div style="width:48%;">

    <p style="margin:0 0 12px 0;">
      <strong>Req No :</strong>
      ${req.requisitionNo || "-"}
    </p>

    <p style="margin:0 0 12px 0;">
      <strong>Requested By :</strong>
      ${req.requestedBy?.toUpperCase() || "-"}
    </p>

    <p style="margin:0;">
      <strong>Status :</strong>
      ${statusText || "-"}
    </p>

  </div>


  <!-- RIGHT DETAILS -->
  <div style="
    width:48%;
    text-align:right;
  ">

    <p style="margin:0 0 12px 0;">
      <strong>Project Code :</strong>
      ${req.storeCode || "-"}
    </p>

    <p style="margin:0 0 12px 0;">
      <strong>Project Name :</strong>
      ${req.storeName?.toUpperCase() || "-"}
    </p>

    <p style="margin:0 0 12px 0;">
      <strong>Location :</strong>
      ${req.storeName?.toUpperCase() || "-"}
    </p>

    <p style="margin:0;">
      <strong>Date :</strong>
      ${formatDate(req.createdAt)}
    </p>

  </div>

</div>

`;
    })()}

<!-- ==========================================
     TABLE
=========================================== -->

<table
  style="
    width:100%;
    border-collapse:collapse;
    border:1px solid #cbd5e0;
    margin-bottom:16px;
    font-size:11px;
    line-height:1.35;
    text-align:left;
    color:#000;
  "
>

<thead>
<tr>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
    S.No
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Part No
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
    Description
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Flag
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Unit
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Req Qty
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Appr Qty
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Received Qty
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Mode / PO No
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; white-space:nowrap;">
    Status
  </th>

  <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700; min-width:140px;">
    Store Remark
  </th>

</tr>
</thead>


<tbody>

${reportData.length === 0
      ? `
    <tr>
      <td
        colspan="11"
        style="
          border:1px solid #cbd5e0;
          text-align:center;
          padding:8px;
        "
      >
        No Items Found
      </td>
    </tr>
  `
      : reportData.map((item, index) => {

        // ==========================================
        // FLAG
        // ==========================================

        const itemFlag =
          String(
            item?.flag || "new"
          ).toUpperCase();


        // ==========================================
        // MODE / PO NO
        // SUPPORT OLD + NEW REQUISITION DATA
        // ==========================================

        let modeOrPoNo = "-";

        const itemFlagValue =
          String(item?.flag || "")
            .trim()
            .toLowerCase();

        const itemStatusValue =
          String(item?.status || "")
            .trim()
            .toLowerCase();

        const poStatusValue =
          String(item?.poStatus || "")
            .trim()
            .toLowerCase();


        // ==========================================
        // GET PO NUMBER
        // ==========================================

        const actualPoNumber =
          item?.poDetails?.poNumber ||
          item?.poNumber ||
          null;


        // ==========================================
        // 1. LOCAL
        // ==========================================

        if (
          itemFlagValue === "local" ||
          itemStatusValue === "local"
        ) {

          modeOrPoNo = "LOCAL";

        }


        // ==========================================
        // 2. TRANSFER
        // ==========================================

        else if (
          itemStatusValue === "tranfer request" ||
          itemStatusValue === "transfer request"
        ) {

          modeOrPoNo = "TRANSFER";

        }


        // ==========================================
        // 3. APPROVED / WAITING FOR PO
        // ==========================================

        else if (
          itemStatusValue === "approved" &&
          poStatusValue === "pending"
        ) {

          modeOrPoNo = "PO";

        }


        // ==========================================
        // 4. GENERATED
        // ==========================================

        else if (
          poStatusValue === "generated"
        ) {

          if (actualPoNumber) {

            modeOrPoNo = actualPoNumber;

          } else {

            modeOrPoNo = "LOCAL";

          }

        }


        // ==========================================
        // 5. PO NUMBER AVAILABLE
        // ==========================================

        else if (actualPoNumber) {

          modeOrPoNo = actualPoNumber;

        }


        // ==========================================
        // 6. NEW PO FLAG
        // ==========================================

        else if (
          itemFlagValue === "po"
        ) {

          modeOrPoNo = "PO";

        }


        // ==========================================
        // FALLBACK
        // ==========================================

        else {

          modeOrPoNo = "-";

        }


        // ==========================================
        // STORE REMARK
        // ==========================================

        const storeRemark =
          item?.storeRemark ||
          item?.remark ||
          "-";


        // ==========================================
        // ITEM STATUS
        // ==========================================

        let itemStatus =
          item?.status || "-";


        if (
          item?.status === "approvedBySuperAdmin"
        ) {

          itemStatus =
            "Approved By Central Team";

        }

        else if (
          item?.status === "approvedByAdmin"
        ) {

          itemStatus =
            "Approved By Project Manager";

        }

        else if (
          item?.status === "approved"
        ) {

          itemStatus =
            "Approved By HO";

        }

        else if (
          item?.status === "recived"
        ) {

          itemStatus =
            "Received";

        }

        else if (
          item?.status === "tranfer request" ||
          item?.status === "transfer request"
        ) {

          itemStatus =
            "Transfer Request";

        }

        else if (
          item?.status === "local"
        ) {

          itemStatus =
            "Local";

        }

        else if (
          item?.status === "rejected"
        ) {

          itemStatus =
            "Rejected";

        }

        else if (
          item?.status === "forceclosed"
        ) {

          itemStatus =
            "Force Closed";

        }

        else if (
          item?.status === "autoclosed"
        ) {

          itemStatus =
            "Auto Closed";

        }

        else if (
          item?.status === "supplier_failed"
        ) {

          itemStatus =
            "Supplier Failed";

        }


        // ==========================================
        // TABLE ROW
        // ==========================================

        return `

<tr>

  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
  ">
    ${index + 1}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:nowrap;
  ">
    ${item.partNo || "-"}
  </td>


  <td className="scrollable-description" style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:normal;
    word-break:break-word;
  ">
    ${item.description || "-"}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:nowrap;
  ">
    ${itemFlag}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:nowrap;
  ">
    ${item.unit || "-"}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
  ">
    ${item.qtyRequired ?? 0}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
  ">
    ${item.approveQty ?? 0}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
  ">
    ${item.qtyRecived ?? 0}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:nowrap;
  ">
    ${modeOrPoNo}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    white-space:nowrap;
    color:#000;
    font-weight:400;
  ">
    ${itemStatus || "-"}
  </td>


  <td style="
    border:1px solid #cbd5e0;
    padding:8px;
    vertical-align:top;
    min-width:140px;
    white-space:normal;
    word-break:break-word;
  ">
    ${storeRemark}
  </td>

</tr>

`;

      }).join("")
    }

</tbody>

</table>


<!-- ==========================================
     APPROVAL FOOTER
=========================================== -->

<div style="
  margin-top:32px;
  font-size:12px;
  line-height:1.35;
  color:#000;
">

  <div style="
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    width:100%;
  ">


    <!-- STORE KEEPER -->

    <div style="
      width:25%;
      text-align:left;
    ">

      <div>
        Prepared&nbsp;By&nbsp;:&nbsp;
        <strong>
          ${req?.requestedBy
      ? String(req.requestedBy).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Store&nbsp;Keeper)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${req?.createdAt
      ? formatDate(req.createdAt)
      : "__________"
    }
        </strong>
      </div>

    </div>


    <!-- PROJECT MANAGER -->

    <div style="
      width:25%;
      text-align:center;
    ">

      <div>
        Approved&nbsp;By&nbsp;:&nbsp;
        <strong>
          ${adminName
      ? String(adminName).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Project&nbsp;Manager)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${adminDate
      ? formatDate(adminDate)
      : "__________"
    }
        </strong>
      </div>

    </div>


    <!-- CENTRAL TEAM -->

    <div style="
      width:25%;
      text-align:center;
    ">

      <div>
        Approved&nbsp;By&nbsp;:&nbsp;
        <strong>
          ${superAdminName
      ? String(superAdminName).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Central&nbsp;Team)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${superAdminDate
      ? formatDate(superAdminDate)
      : "__________"
    }
        </strong>
      </div>

    </div>


    <!-- HO / DIRECTOR -->

    <div style="
      width:25%;
      text-align:right;
    ">

      <div>
        Approved&nbsp;By
      </div>

      <div style="
        margin-top:4px;
        visibility:hidden;
      ">
        APPROVER NAME
      </div>

      <div style="margin-top:4px;">
        HO&nbsp;(Director)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${bossDate
      ? formatDate(bossDate)
      : "__________"
    }
        </strong>
      </div>

    </div>


  </div>

</div>
</div>
</body>
</html>
`;
};

export default getRequisitionPrintTemplate;